import apiConfig from '@/config/api'
import OrderAppLib from '@dimorder/orderapp-lib'

const dimorderApi = new OrderAppLib.api.Client(apiConfig.baseUrl)

export default dimorderApi
